import React, { useReducer } from 'react';
import cls from 'classnames';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './Tools.scss';

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    case 'UPDATE_TOGGLE':
      newState.dropDownToggle = !newState.dropDownToggle;
      return newState;
    default:
      return newState;
  }
};

/**
 * @typedef {{title: string, value: any}} selectItem
 * @typedef {selectItem[]} selectItems
 */

/**
 * @param {object} props
 * @param {selectItems[]} props.items
 * @param {selectItems} props.selected
 * @param {(item: selectItem)=> void} props.onSelected
 *
 */

function Tool_dropDown({ items, selected, onSelected, ...props }) {
  const [state, dispatch] = useReducer(reducer, {
    dropDownToggle: false,
  });
  function buildList() {
    return items.map((e, index) => (
      <DropdownItem
        key={index}
        className={cls(
          'Tool__dropDown__list p-2',
          selected
            ? selected === e.value
              ? 'Tool__dropDown__list_selected'
              : ''
            : null
        )}
        children={e.title}
        onClick={() => {
          dispatch({
            type: 'UPDATE',
            payload: [{ key: 'selectedItem', val: e }]
          });
          onSelected(e);
        }}
      />
    ));
  }

  if (!Array.isArray(items) || items.length <= 0) {
    return null;
  }
  
  return (
    <div className="Tool Tool__dropDown">
      <Dropdown
        className="Tool Tool__dropDown"
        isOpen={state.dropDownToggle}
        size="sm"
        toggle={() => dispatch({ type: 'UPDATE_TOGGLE' })}
      >
        <DropdownToggle
          caret
          className="Tool__dropDown__button d-flex align-items-center"
        >
          {selected ? items.find(f => f.value === selected).title : ''}
        </DropdownToggle>
        <DropdownMenu className="Tool__dropDown__menu">
          <PerfectScrollbar
            style={{
              maxHeight: '160px'
            }}
          >
            {buildList()}
          </PerfectScrollbar>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default Tool_dropDown;
